var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useMemo } from 'react';
import { View } from 'react-native';
import { getEngagementRailWidgetStyles } from './EngagementRailWidgetStyles';
import { ItemsToBeShownInRow } from './EngagementRailWidgetPropTypes';
import EngagementRow from './components/engagement-rows/EngagementRow';
import { getTestId } from '@airtel/air-design-system';
export var getItemsToBeShownInRow = data => {
  if (!data || data.length <= 4) {
    return data === null || data === void 0 ? void 0 : data.length;
  }
  if (data.length % 4 === 0) {
    return ItemsToBeShownInRow.FOUR;
  }
  if (data.length % 3 === 0) {
    return ItemsToBeShownInRow.THREE;
  }
  return data.length % 4 > data.length % 3 ? ItemsToBeShownInRow.FOUR : ItemsToBeShownInRow.THREE;
};
export var EngagementRailWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'EngagementRailWidget' : _props$testID,
    style = props.style,
    listData = props.listData,
    itemsToBeShownInRow = props.itemsToBeShownInRow,
    restProps = __rest(props, ["testID", "style", "listData", "itemsToBeShownInRow"]);
  var EngagementRailWidgetStyles = getEngagementRailWidgetStyles();
  var itemsPerRow = itemsToBeShownInRow || useMemo(() => getItemsToBeShownInRow(listData), [listData]);
  var totalRows = 0;
  var manipulateData = (rawData, chunkSize) => {
    var result = [];
    totalRows = Math.ceil((rawData === null || rawData === void 0 ? void 0 : rawData.length) / chunkSize);
    rawData = rawData === null || rawData === void 0 ? void 0 : rawData.map((item, index) => Object.assign(Object.assign({}, item), {
      index: index
    }));
    for (var i = 0; i < totalRows; i++) {
      result.push(rawData === null || rawData === void 0 ? void 0 : rawData.slice(i * chunkSize, (i + 1) * chunkSize));
    }
    return result;
  };
  var modifiedData = manipulateData(listData, itemsPerRow);
  return _jsx(View, Object.assign({
    style: [EngagementRailWidgetStyles.container, style],
    testID: testID
  }, {
    children: modifiedData === null || modifiedData === void 0 ? void 0 : modifiedData.map((item, index) => {
      return _createElement(EngagementRow, Object.assign({
        rowData: item,
        height: 100 / totalRows + "%",
        itemsToBeShownInRow: itemsPerRow
      }, restProps, {
        key: testID + ("_engagement-row-" + index)
      }, getTestId(testID, "engagement-row-" + index)));
    })
  }));
};
EngagementRailWidgetComponent.genericRendererKey = 'AirEngagementRailWidget';